import React from 'react';
import { FileTextIcon } from 'lucide-react';
export function CSeriesSection() {
  return <div className="bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden" data-id="element-312">
      <div className="bg-[#002d4d] text-white py-6 px-8 flex flex-col md:flex-row md:items-center justify-between" data-id="element-313">
        <div data-id="element-314">
          <h2 className="text-3xl font-bold mb-1" data-id="element-315">Bodor C Series</h2>
          <h3 className="text-white/80 font-medium text-lg" data-id="element-316">
            Economical Fiber Laser Plate Cutting Machine
          </h3>
        </div>
      </div>

      <div className="p-8" data-id="element-317">
        <div className="grid md:grid-cols-12 gap-12 items-center mb-10" data-id="element-318">
          <div className="md:col-span-5 flex justify-center bg-gray-50 rounded-xl p-6 border border-gray-100" data-id="element-319">
            <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/BODOR/2023/Fiber%20Laser%20C%20Series%20Bodor.png800x800.png" alt="Bodor C Series" className="block max-h-[350px] w-auto object-contain drop-shadow-xl" data-id="element-320" />
          </div>
          <div className="md:col-span-7" data-id="element-321">
            <ul className="space-y-4 text-gray-700" data-id="element-322">
              <li data-id="element-323">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-324">
                  Economical Sheet Fiber Laser Cutting Machine with Full
                  Protection
                </strong>
                <span className="text-gray-600 ml-4 block border-l-2 border-gray-200 pl-3" data-id="element-325">
                  Maximum cutting area reaches up to 12000mm*2500mm, suitable
                  for a variety of cutting options.
                </span>
              </li>
              <li data-id="element-326">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-327">
                  Active Anti-collision Function
                </strong>
                <span className="text-gray-600 ml-4 block border-l-2 border-gray-200 pl-3" data-id="element-328">
                  Effectively reduce the damage rate of laser heads, help you
                  save maintenance cost.
                </span>
              </li>
              <li data-id="element-329">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-330">
                  One-click Processing
                </strong>
                <span className="text-gray-600 ml-4 block border-l-2 border-gray-200 pl-3" data-id="element-331">
                  All functions of the system are distributed logically and
                  orderly to achieve fully automatic mass production.
                </span>
              </li>
              <li data-id="element-332">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-333">
                  No Quiver when Cutting Thin Sheet
                </strong>
                <span className="text-gray-600 ml-4 block border-l-2 border-gray-200 pl-3" data-id="element-334">
                  C Series is capable of cutting edges of thin sheets and
                  ensures no quivering marks.
                </span>
              </li>
              <li data-id="element-335">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-336">
                  Stretching Aluminum Crossbeam
                </strong>
                <span className="text-gray-600 ml-4 block border-l-2 border-gray-200 pl-3" data-id="element-337">
                  Rigidity increases by 60% | Weight goes down by 20% |
                  Equipment running speed increases by 50%
                </span>
              </li>
              <li data-id="element-338">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-339">
                  Welded Bed with Tenon-and-mortise Joint
                </strong>
                <span className="text-gray-600 ml-4 block border-l-2 border-gray-200 pl-3" data-id="element-340">
                  Each frame of bed is welded after mortise-and-tenon joint to
                  achieve better stability and firmness.
                </span>
              </li>
            </ul>

            <div className="flex flex-col sm:flex-row gap-4 mt-8 pt-6 border-t border-gray-100" data-id="element-341">
              <a href="https://www.peakedm.com/m7/Bodor%20C%20Series--c-series-economical-fiber-laser-plate-cutting-machine.html" className="inline-flex items-center justify-center px-6 py-3 bg-[#002d4d] text-white font-bold uppercase text-sm rounded-md hover:bg-[#f5693d] transition-colors" data-id="element-342">
                <span className="mr-2" data-id="element-343">+</span> Discover More
              </a>
              <a href="https://www.peakedm.com/uploaded/files/Bodor%20Files/Brochure%20Bodor%20Laser%20C-series.pdf?direct=1" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-6 py-3 border-2 border-[#002d4d] text-[#002d4d] font-bold uppercase text-sm rounded-md hover:bg-[#002d4d] hover:text-white transition-colors" data-id="element-344">
                <FileTextIcon className="w-4 h-4 mr-2" data-id="element-345" /> Download Brochure
              </a>
            </div>
          </div>
        </div>

        {/* Spec Table */}
        <div className="overflow-x-auto rounded-lg border border-gray-200 shadow-sm" data-id="element-346">
          <table className="w-full text-sm text-left text-gray-600" data-id="element-347">
            <thead className="text-xs text-gray-700 uppercase bg-gray-100 border-b border-gray-200" data-id="element-348">
              <tr data-id="element-349">
                <th scope="col" className="px-6 py-4 font-bold border-r border-gray-200 w-1/4" data-id="element-350">
                  Model
                </th>
                <th scope="col" className="px-6 py-4 font-bold text-center border-r border-gray-200" data-id="element-351">
                  C12
                </th>
                <th scope="col" className="px-6 py-4 font-bold text-center border-r border-gray-200" data-id="element-352">
                  C8
                </th>
                <th scope="col" className="px-6 py-4 font-bold text-center border-r border-gray-200" data-id="element-353">
                  C6
                </th>
                <th scope="col" className="px-6 py-4 font-bold text-center border-r border-gray-200" data-id="element-354">
                  C4
                </th>
                <th scope="col" className="px-6 py-4 font-bold text-center" data-id="element-355">
                  C3
                </th>
              </tr>
            </thead>
            <tbody data-id="element-356">
              <tr className="bg-white border-b border-gray-200 hover:bg-gray-50" data-id="element-357">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-358">
                  Working Area
                </th>
                <td className="px-6 py-4 text-center border-r border-gray-200" data-id="element-359">
                  12500*2600mm
                </td>
                <td className="px-6 py-4 text-center border-r border-gray-200" data-id="element-360">
                  8000*2500mm
                </td>
                <td className="px-6 py-4 text-center border-r border-gray-200" data-id="element-361">
                  6100*2500mm
                </td>
                <td className="px-6 py-4 text-center border-r border-gray-200" data-id="element-362">
                  4000*2000mm
                </td>
                <td className="px-6 py-4 text-center" data-id="element-363">3048*1524mm</td>
              </tr>
              <tr className="bg-white border-b border-gray-200 hover:bg-gray-50" data-id="element-364">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-365">
                  Laser Power
                </th>
                <td colSpan={2} className="px-6 py-4 text-center border-r border-gray-200" data-id="element-366">
                  40kW/30kW/22kW/20kW/12kW/6kW/3kW
                </td>
                <td colSpan={3} className="px-6 py-4 text-center" data-id="element-367">
                  40kW/30kW/22kW/20kW/12kW/6kW/3kW/2kW/1.5kW
                </td>
              </tr>
              <tr className="bg-white border-b border-gray-200 hover:bg-gray-50" data-id="element-368">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-369">
                  Positioning accuracy
                </th>
                <td colSpan={5} className="px-6 py-4 text-center" data-id="element-370">
                  ±0.05mm
                </td>
              </tr>
              <tr className="bg-white border-b border-gray-200 hover:bg-gray-50" data-id="element-371">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-372">
                  Repositioning accuracy
                </th>
                <td colSpan={5} className="px-6 py-4 text-center" data-id="element-373">
                  ±0.03mm
                </td>
              </tr>
              <tr className="bg-white border-b border-gray-200 hover:bg-gray-50" data-id="element-374">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-375">
                  Max. linkage speed
                </th>
                <td colSpan={5} className="px-6 py-4 text-center" data-id="element-376">
                  110m/min
                </td>
              </tr>
              <tr className="bg-white hover:bg-gray-50" data-id="element-377">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-378">
                  Max. acceleration
                </th>
                <td colSpan={5} className="px-6 py-4 text-center" data-id="element-379">
                  1.5G
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}